module.exports = "/assets/data/2f082949edcf30ae111c3184228f463a-TQ5.data.json";